import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import { Application } from '../../../../../../application/application'
import { Steps } from '../../../../..'
import { Options } from '../interfaces'
import { isOrientationPageRefresh } from './utils/is-orientation-page-refresh'

import { JAPAN_DX_ENABLE_ORIENTATION } from '../../../../../../../experimentConstants'

export function isProgressionStep(application: Application, options: Options) {
  const { step, hasCompletedFirstDelivery } = options
  const hasScheduledOrientation = Boolean(application.dasherOrientation)

  const shouldEnableJapanDxOrientationStep = isFeatureFlagEnabled(
    JAPAN_DX_ENABLE_ORIENTATION
  )

  const shouldShowProgressionCheckStep =
    !shouldEnableJapanDxOrientationStep ||
    step === Steps.ProgressionCheck ||
    isOrientationPageRefresh(options) ||
    hasCompletedFirstDelivery ||
    hasScheduledOrientation

  return shouldShowProgressionCheckStep
}
